var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7765 7.5656L14.8008 14.2734L12.7126 15.4547H7.41796L3.19921 14.2734C3.19921 14.2734 1.64533 8.96828 1.29721 7.79768L1.22346 7.5656C1.1813 7.41797 1.20231 7.25977 1.28663 7.12271L2.52067 6.61638L5.61442 7.8187L7.96646 3.81088H10.0335L12.3856 7.8187L15.4793 6.61638L16.7765 7.5656Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7765 7.5656L14.8008 14.2734L12.7126 15.4547H9V3.81088H10.0335L12.3856 7.8187L15.4793 6.61638L16.7765 7.5656Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 14.2734V15.8555C3.19922 16.1507 3.43117 16.3828 3.72656 16.3828H14.2734C14.5688 16.3828 14.8008 16.1507 14.8008 15.8555V14.2734H3.19922Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.61719C8.12453 1.61719 7.41797 2.32375 7.41797 3.19922C7.41797 4.0957 8.15625 4.78125 9 4.78125C9.87547 4.78125 10.582 4.06412 10.582 3.19922C10.582 2.32375 9.87547 1.61719 9 1.61719Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.418 7.94531C15.9721 7.94531 15.5831 7.77173 15.2964 7.48485C14.9919 7.16405 14.8359 6.77994 14.8359 6.36328C14.8359 5.49097 15.5457 4.78125 16.418 4.78125C17.2903 4.78125 18 5.49097 18 6.36328C18 7.2356 17.2903 7.94531 16.418 7.94531Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 7.94531C0.709717 7.94531 0 7.2356 0 6.36328C0 5.49097 0.709717 4.78125 1.58203 4.78125C2.45435 4.78125 3.16406 5.49097 3.16406 6.36328C3.16406 7.24576 2.45366 7.94531 1.58203 7.94531Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.78125V1.61719C9.87547 1.61719 10.582 2.32375 10.582 3.19922C10.582 4.06412 9.87547 4.78125 9 4.78125Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 14.2734V15.8555C14.8008 16.1507 14.5688 16.3828 14.2734 16.3828H9V14.2734H14.8008Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6156 9.54834C11.5523 9.34798 11.3836 9.21092 11.1833 9.17934L10.002 9.01056L9.47461 7.96631C9.37972 7.79767 9.18979 7.70264 9 7.70264C8.81021 7.70264 8.62029 7.79767 8.52539 7.96631L7.99805 9.01056L6.81674 9.17934C6.61638 9.21092 6.44774 9.34798 6.38443 9.54834C6.3317 9.73827 6.38443 9.9492 6.53206 10.0863L7.37581 10.8984L7.17545 12.0376C7.14372 12.2274 7.21761 12.4277 7.38638 12.5543C7.54459 12.6704 7.7661 12.6808 7.93474 12.5965L9 12.048L10.0653 12.5965C10.2445 12.6914 10.4554 12.6702 10.6138 12.5543C10.7824 12.4277 10.8563 12.2274 10.8246 12.0374L10.6242 10.8984L11.4679 10.0863C11.6156 9.9492 11.6684 9.73827 11.6156 9.54834Z",
    fill: "#FF9F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0653 12.5965L9 12.048V7.70264C9.18979 7.70264 9.37971 7.79767 9.47461 7.96631L10.002 9.01056L11.1833 9.17934C11.3836 9.21092 11.5523 9.34798 11.6156 9.54834C11.6683 9.73827 11.6156 9.9492 11.4679 10.0863L10.6242 10.8984L10.8246 12.0376C10.8563 12.2274 10.7824 12.4277 10.6136 12.5543C10.4554 12.6702 10.2445 12.6914 10.0653 12.5965Z",
    fill: "#FF7816"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.28f26b979f0626a644ba9c58a25e537b.svg";
export { ForwardRef as ReactComponent };